import { render } from "./FieldErrors.vue?vue&type=template&id=4d665d55"
import script from "./FieldErrors.vue?vue&type=script&lang=ts"
export * from "./FieldErrors.vue?vue&type=script&lang=ts"
script.render = render

export default script